import { Button, Modal, ModalBody, ModalContent, ModalFooter, ModalHeader } from '@ds';

type ConfirmationModalProps = {
  title: string;
  description: string;
  isOpen: boolean;
  size?: 'md' | 'xs' | 'sm' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | 'full';
  onChangeActive: () => Promise<void>;
  onClose: () => void;
};

export const ConfirmationModal = ({
  title,
  description,
  isOpen,
  size = 'xl',
  onChangeActive,
  onClose,
}: ConfirmationModalProps) => {
  const changeActive = async () => {
    await onChangeActive();
    onClose();
  };

  return (
    <Modal
      size={size}
      isOpen={isOpen}
      onClose={onClose}
      backdrop="opaque"
      hideCloseButton
      classNames={{
        base: 'px-6',
        body: 'border-y-1 border-base-30 px-0 py-6 text-l-r',
        header: 'px-0 font-secondary text-hl! text-base-20',
        footer: 'px-0 flex gap-6',
      }}
    >
      <ModalContent>
        <>
          <ModalHeader>{title}</ModalHeader>
          <ModalBody>{description}</ModalBody>
          <ModalFooter>
            <Button className="w-full shrink" size="md" variant="outline" onClick={onClose}>
              Discard
            </Button>
            <Button className="w-full shrink" size="md" color="default" variant="solid" onClick={changeActive}>
              Confirm
            </Button>
          </ModalFooter>
        </>
      </ModalContent>
    </Modal>
  );
};
